// @ts-nocheck
/* eslint-disable */
export default class Melown3dLoader {
	/**
	 * Vytvoreni loaderu pro 3d - pomoci rozmeru a polohy vykresli do canvasu letecke snimky.
	 *
	 * @param  {Number} width Sirka obrazku
	 * @param  {Number} height Vyska obrazku
	 * @param  {Number} x Stred projekce ve WGS84
	 * @param  {Number} y Stred projekce ve WGS84
	 * @param  {Number} z Zoom projekce v mercatoru
	 * @return {Element} Canvas
	 */
	constructor(width, height, x, y, z, imgUrl, imgCrossOrigin) {
		this._const = {
			tileSize: 256,
			query: "{zoom}-{x}-{y}",
			screenCoefficients: {
				x: 1,
				y: 1
			}
		};

		this._width = width;
		this._height = height;
		this._center = {
			x: x,
			y: y
		};
		this._z = z;
		this._url = imgUrl;
		this._imgCrossOrigin = imgCrossOrigin;
		this._canvas = document.createElement("canvas");
		this._ctx = this._canvas.getContext("2d");
		this._canvas.width = width;
		this._canvas.height = height;

		// dlazdice
		this._createTiles();

		return this._canvas;
	}

	/**
	 * Vytvoreni dlazdic.
	 */
	_createTiles() {
		let ts = this._const.tileSize;

		/* velikost pruhledu */
		let half = this._getMapSize(0.5);
		let w = half.x;
		let h = half.y;

		/* vyrobit seznam dlazdic ve viewportu */
		for (let i=-w; i<w+ts; i+=ts) {
			for (let j=-h; j<h+ts; j+=ts) {
				let tile = this._pixelToTile(i, j);

				if (!tile) { continue; }

				let url = this._buildURL(tile);
				let pos = this._tileToPixel(tile, this._center, this._z);

				// vytvorime obr.
				let img = new Image();
				img.crossOrigin = this._imgCrossOrigin;
				img.onload = () => {
					this._ctx.drawImage(img, w + Math.round(pos.x), h + Math.round(pos.y));
					img = null;
				};
				img.src = url;
			}
		}
	}

	/**
	 * Ziskani rozmeru platna.
	 *
	 * @param  {Number} [scale = 1] Upravit vysledne rozmery
	 * @return {Object}
	 */
	_getMapSize(scale) {
		scale = scale || 1;

		return {
			x: Math.round(this._width * scale),
			y: Math.round(this._height * scale)
		};
	}

	/**
	 * Prevede souradnice x a na dlazdici.
	 *
	 * @param  {Number} x Souradnice X
	 * @param  {Number} y Souradnice Y
	 * @return {Object}
	 */
	_pixelToTile(x, y) {
		let pixel = {
			x: x,
			y: y
		};

		let abs = this._pixelToAbsolutePixel(pixel, this._center, this._z);
		let world = this._getWorldSize(this._z);
		if (abs.y < 0 || abs.y >= world.y) { return null; }

		return {
			zoom: this._z,
			tileSize: this._const.tileSize,
			x: Math.floor(abs.x / this._const.tileSize),
			y: Math.floor(abs.y / this._const.tileSize)
		};
	}

	/**
	 * Prevede pixel na absolutni v zavislosti na vzdalenosti od stredu.
	 *
	 * @param  {Object} pixel Vstupni pixel
	 * @param  {Object} center Stred projekce
	 * @param  {Number} zoom Mercator zoom
	 * @return {Object} Pixel na absolutni pixel
	 */
	_pixelToAbsolutePixel(pixel, center, zoom) {
		let abs = this._project(center, zoom);
		abs.x += this._const.screenCoefficients.x * pixel.x;
		abs.y += this._const.screenCoefficients.y * pixel.y;

		return abs;
	}

	/**
	 * Prevede data dlazdice na pixel.
	 *
	 * @param  {Object} tile Data s dlazdici
	 * @param  {Object} centerArg Stred projekce
	 * @param  {Number} zoom Mercator zoom
	 * @return {Object}
	 */
	_tileToPixel(tile, centerArg, zoom) {
		let ts = tile.tileSize;
		let x = tile.x * tile.tileSize;
		let y = tile.y * tile.tileSize;
		let coef = this._const.screenCoefficients;
		let center = this._project(centerArg, zoom);

		let px = { x: x - center.x, y: y - center.y};
		if (coef.x == -1) { px.x = - px.x - ts; }
		if (coef.y == -1) { px.y = - px.y - ts; }

		return px;
	}

	/**
	 * Ziskeni velikosti sveta v zavislosti na zoomu.
	 *
	 * @param  {Number} [zoom = 0] Vlastni zoom
	 * @return {Object}
	 */
	_getWorldSize(zoom) {
		let size = Math.pow(2, zoom+8);

		return {
			x: size,
			y: size
		};
	}

	/**
	 * Prepocet souradnic na pixel.
	 *
	 * @param  {Object} coords Vstupni souradnice
	 * @param  {Number} zoom Mercator zoom
	 * @return {Object}
	 */
	_project(coords, zoom) {
		let wgs = [this._center.x, this._center.y];
		let world = this._getWorldSize(zoom);

		let x = (wgs[0] + 180) / 360 * world.x;
		let y = wgs[1] * Math.PI / 180;

		let f = Math.min(Math.max(Math.sin(y), -0.9999), 0.9999);
		y = (1.0-(0.5*Math.log((1+f)/(1-f)))/Math.PI)/2 * world.y;

		return {
			x: x,
			y: y
		};
	}

	/**
	 * Pomoci dat dlazdice vytvori jeji url.
	 *
	 * @param  {Object} tile Vstupni dlazdice
	 * @return {String}
	 */
	_buildURL(tile) {
		let url = this._url + this._buildQuery(tile);
		let mapServerNumber = 1 + ((tile.x + tile.y) & 3);

		return url.replace(/#/, mapServerNumber);
	}

	/**
	 * Vytvoreni url query.
	 *
	 * @param  {Object} tile Vstupni dlazdice
	 * @return {String}
	 */
	_buildQuery(tile) {
		let ppx = (tile.x << (28 - tile.zoom)).toString(16);
		let ppy = (tile.y << (28 - tile.zoom)).toString(16);

		let world = this._getWorldSize(tile.zoom);
		let count = world.x / tile.tileSize;

		return this._formatString(this._const.query, {
			zoom: this._z,
			x: this._numMod(tile.x, count),
			y:tile.y
		});
	}

	/**
	 * Format retezce, nahrady vsech polozek objektu s {value} = XYZ.
	 *
	 * @param  {String} str Vstupni retezec
	 * @param  {Object} params Objekt s klici na nahrady hodnot
	 * @return {String}
	 */
	_formatString(str, params) {
		let output = str;

		for (let key in params) {
			output = output.replace(new RegExp("{" + key + "}", "g"), params[key]);
		}

		return output;
	}

	/**
	 * Mod cisla.
	 *
	 * @param  {Number} value Vstupni hodnota
	 * @param  {Number} modulus
	 * @return {Number}
	 */
	_numMod(value, modulus) {
		let remainder = value % modulus;

		return (remainder < 0 ? remainder + modulus : remainder);
	}
}
